import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EventsList from './eventsList';
import logo_stb_white from '../img/logo-stb-white.png';
import logo_stb from '../img/logo-stb.png';
import './allevents.css';
import './footer.css';

// category: 'event'（イベント一覧） / 'interview'（インタビュー一覧）
function AllEvents({ category = 'event' }) {
  const { eventId } = useParams();
  const navigate = useNavigate();

  const isInterview = category === 'interview';
  const listLabel = isInterview ? 'インタビュー一覧' : 'イベント一覧';
  const listPath = isInterview ? '/interviews' : '/allevents';
  const homeHash = isInterview ? '/#interviews' : '/#events';

  return (
    <div>
      <div className='allevents-container'>
        <header className="allevents-header">
          <a href="/">
            <img src={logo_stb_white} alt="Science Tokyo Biz logo" className="allevents-logo" />
          </a>
        </header>

        {/* パンくず表示 */}
        <div className="allevents-breadcrumb">
          <span onClick={() => navigate(homeHash)}>ホーム</span>
          <span> / </span>
          <span onClick={() => navigate(listPath)} style={{ cursor: 'pointer' }}>{listLabel}</span>
          {eventId && (
            <>
              <span> / </span>
              <span className="breadcrumb-id">{eventId}</span>
            </>
          )}
        </div>
        <EventsList key={eventId || 'list'} selectedId={eventId} category={category} />

        {/* 戻るボタン（詳細表示時のみ表示） */}
        {eventId && (
          <button className="back-button" onClick={() => navigate(listPath)}>
            {listLabel}に戻る
          </button>
        )}

        <button className="back-button-white" onClick={() => navigate(homeHash)}>
          ホームに戻る
        </button>

      </div>
      <footer className="footer">
        <div className="footer-content">
          <img src={logo_stb} alt="logo-Science_Tokyo_Biz" className="icon-footer" />
          <nav className="footer-nav">
            <a href="/#vision">Vision</a>
            <a href="/#events">Events</a>
            <a href="/#interviews">Interview</a>
            <a href="/#partners">Partners</a>
            <a href="/#contact">Contact</a>
          </nav>
        </div>
        <p className="footer-copy">&copy; 2025 Science Tokyo Biz. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default AllEvents;
